import { db } from '../firestore_wrapper';

export const getExtensionInfo = () => {
  return db.collection('chrome_extension').doc('unakite');
};

export const updateExtensionVersionString = versionString => {
  return getExtensionInfo().set(
    {
      chromeWebStoreVersion: versionString
    },
    {
      merge: true
    }
  );
};

export const getAnonymizationInfo = () => {
  return db.collection('logistics').doc('anonymization');
};



// WEBPACK FOOTER //
// ../shared-components/src/firebase/wrappers/misc_functions.js